var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.link && _vm.path)?_c('nuxt-link',{staticClass:"rk-btn",class:[_vm.styleOpts, _vm.style],attrs:{"to":_vm.path}},[_vm._t("default")],2):_c('button',{staticClass:"rk-btn",class:[_vm.styleOpts, _vm.style],on:{"click":_vm.click}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }